import React from 'react';
import PropTypes from 'prop-types';
import {Card, CardContent, Grid} from "@mui/material";
import CustomButton from "../../../../components/CustomButton";
import {FormattedMessage} from "react-intl";
import {greyishBlue100, greyishBlue600, red500} from "../../../../assets/jss/main";

StickyFooter.propTypes = {
    openScanModal: PropTypes.func.isRequired
};

function StickyFooter({openScanModal}) {
    return (
        <Card sx={{
            position: 'sticky',
            bottom: 0,
            maxHeight: '90px',
            marginTop: '8px',
            marginLeft: "240px",
            boxShadow: 0,
            borderRadius: 0,
            border: '1px solid',
            borderBottom: 0,
            borderRight: 0,
            borderColor: greyishBlue100
        }}>
            <CardContent>
                <Grid container justifyContent="space-between" flexWrap={'nowrap'}>
                    <Grid item container sx={{marginLeft: '48px'}} flexWrap="nowrap" alignItems="center">
                        <Grid item>
                            <CustomButton onClick={() => openScanModal(true)}>
                                <FormattedMessage id="retailer.picking.list.launchScan" />
                            </CustomButton>
                        </Grid>

                        <Grid item container direction={'column'} sx={{marginLeft: '8px'}}>
                            <Grid item>
                                <FormattedMessage id="retailer.picking.list.articleToPrepare" values={{number: <span style={{fontWeight: 'bold'}}>12</span>}} />
                            </Grid>
                            <Grid item sx={{color: greyishBlue600}}>
                                <FormattedMessage id="retailer.picking.list.discount" values={{orga: "TVO", price: <span style={{color: 'black'}}>12</span>}}/>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container flexWrap={'nowrap'} sx={{color: greyishBlue600}}>
                        <Grid item container direction={'column'} flexWrap={'nowrap'}>
                            <Grid item textAlign={'end'} whiteSpace={'nowrap'}>
                                <FormattedMessage id="retailer.picking.list.total.outlet" values={{value: <span style={{color: 'black', fontWeight: 'bold'}}>12</span>}} />
                            </Grid>
                            <Grid item textAlign={'end'}>(12)</Grid>
                        </Grid>
                        <Grid item container direction={'column'} flexWrap={'nowrap'}>
                            <Grid item textAlign={'end'} whiteSpace={'nowrap'}>
                                <FormattedMessage id="retailer.picking.list.total.return" values={{value: <span style={{color: red500, fontWeight: 'bold'}}>12</span>}} />
                            </Grid>
                            <Grid item textAlign={'end'}>(12)</Grid>
                        </Grid>
                        <Grid item container direction={'column'} flexWrap={'nowrap'}>
                            <Grid item textAlign={'end'} whiteSpace={'nowrap'}>
                                <FormattedMessage id="retailer.picking.list.total" values={{value: <span style={{color: 'black', fontWeight: 'bold'}}>12</span>}} />
                            </Grid>
                            <Grid item textAlign={'end'}>(12)</Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

export default StickyFooter;